import type { HearingParticipantStatus } from 'features/call/call-hearing/interfaces';
import {
  EmergencyCallDetailsStatus,
  EmergencyConnectionPoint,
} from 'features/emergency/enums';

interface ResolveEmergencyCallDetailsStatusArgs {
  status: HearingParticipantStatus;
  hasConnected?: boolean;
}

export const resolveEmergencyCallDetailsStatus = ({
  status,
  hasConnected,
}: ResolveEmergencyCallDetailsStatusArgs) => {
  switch (status) {
    case 'connecting':
    case 'disconnected':
      return hasConnected
        ? EmergencyCallDetailsStatus.CALLEE_RECONNECT
        : EmergencyCallDetailsStatus.CALLEE_DISCONNECTED;

    case 'connected':
      return EmergencyCallDetailsStatus.CALLEE_CONNECTED;
  }
};

interface ResolveEmergencyConnectionPointArgs {
  primaryHearingPhoneNumber: string;
  phoneNumberPSAP: string;
  phoneNumberECRC: string;
}

export const resolveEmergencyConnectionPoint = ({
  primaryHearingPhoneNumber,
  phoneNumberPSAP,
  phoneNumberECRC,
}: ResolveEmergencyConnectionPointArgs) => {
  if (primaryHearingPhoneNumber === phoneNumberPSAP) {
    return EmergencyConnectionPoint.PSAP;
  }

  if (primaryHearingPhoneNumber === phoneNumberECRC) {
    return EmergencyConnectionPoint.ECRC;
  }

  return EmergencyConnectionPoint.OTHER;
};

interface ShouldSyncEmergencyConnectionPointArgs {
  isAcceptingUserAndCurrentlyTeaming: boolean;
  primaryHearingStatus: HearingParticipantStatus;
}

export const shouldSyncEmergencyConnectionPointFromPrimaryHearing = ({
  isAcceptingUserAndCurrentlyTeaming,
  primaryHearingStatus,
}: ShouldSyncEmergencyConnectionPointArgs) =>
  isAcceptingUserAndCurrentlyTeaming && primaryHearingStatus === 'connected';
